import { Component, OnDestroy, OnInit } from '@angular/core';
import { Application } from '../../application';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RestapiService } from '../services/restapi.service';
import { ActivatedRoute } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { GoogleAnalyticsService } from '../services/google-analytics.service';
import amplitude from 'amplitude-js';

@Component({
  selector: 'app-fingerprintid',
  templateUrl: './fingerprintid.component.html',
  styleUrls: ['./fingerprintid.component.css']
})
export class FingerprintidComponent implements OnInit {

  uploadForm: FormGroup;
  submitted = false;
  showsuccess = false;
  showSuccessMessage: string;
  userName: any;
  responseMesage: string;
  showErrorMessage: string;
  showerror: boolean;
  authCode: any;
  start = false;
  authUserData: any;
  jsonData;
  applicationList: any = [];
  sortedData: any = [];
  applicationLog: string;
  linkedHoverCopiedText = 'Copy Link';
  isLinkCopied: boolean = false;
  mainUrl: string = '';
  externalUrl: string = '';
  isViewReqBtnClicked: boolean = false;
  fingerPrint: any ='';
  serverName: any;
  ipAddress: any;
  port: any;
  isChecked: boolean = false;
  feedBackDetails: string;
  urlNeedToHit: any;
   url: string='';
  public  instance1 = amplitude.getInstance().init("ff1f348e52206af809b752482e39fb8e");

  constructor(private formBuilder: FormBuilder,
    private apiService: RestapiService,
    private httpClient: HttpClient,
    private router: ActivatedRoute,
    public googleAnalyticsService: GoogleAnalyticsService) { }





  ngOnInit(): void {

    // This if block is check the url and url contain fingerprint as param then it store it in local storage 
    if (this.router.snapshot.queryParams['fingerprint']  ) {
      localStorage.setItem('URLHIT', window.location.href);
      console.log("Inside if ",localStorage.getItem('URLHIT'));
    }
  /*  else if(this.router.snapshot.queryParams['fingerprint'] && localStorage.hasOwnProperty("FLAG_URL_HIT") 
      && localStorage.getItem('FLAG_URL_HIT') ==='false' ) {
        localStorage.setItem('URLHIT', '');
        console.log("authenticate user not req");
       alert("Inside else if "+localStorage.getItem('URLHIT'));
    }
*/
    
   

    this.jsonData = null;
    this.showsuccess = false;
    this.createForm();   
    const hostname = window.location.hostname;
    console.log('Host Name : ' + hostname);

    if (hostname === 'localhost') {
     localStorage.setItem('TOKEN', '123');
     localStorage.setItem('TOKEN_EXPIRATION_SECONDS', new Date().getTime()+"");
      localStorage.setItem('NAME', 'Ajinkya Bijwe');
     localStorage.setItem('EMAIL', 'abijwe@cisco.com');
    }
        
    if (!localStorage.hasOwnProperty("TOKEN")) {
      localStorage.setItem('TOKEN', '');
    }
    if (!localStorage.hasOwnProperty("TOKEN_EXPIRATION_SECONDS")) {
      localStorage.setItem('TOKEN_EXPIRATION_SECONDS', '');
    }

    if(this.calculateTokenSeconds() > 3600){
      localStorage.setItem('TOKEN', '');
      localStorage.setItem('TOKEN_EXPIRATION_SECONDS','');
    }
    if(isNaN(this.calculateTokenSeconds())){
      localStorage.setItem('TOKEN', '');
    }
    

    

    const self = this;
    self.router.queryParams.subscribe((params) => {
      self.authCode = params.code;
      /* if (
        !isNullOrUndefined(self.authCode) &&
        self.authCode !== '' &&
        isNullOrUndefined(localStorage.getItem('TOKEN'))
      ) */ 
      if (
        self.authCode != null &&
        self.authCode !== '' &&
        localStorage.getItem('TOKEN')===''
      ){
        console.log("authenticate");
        self.authenticate();
      } else {
        console.log("initMethods");
        self.initMethods();        
      }
    

    });

    if (this.setFieldsFromUrlParameters() &&  localStorage.getItem('TOKEN')!='') {
      this.onSubmit();
    }

    

  }

  authenticate() {
    console.log('inside authenticate');
    this.start = true;
    this.apiService.getAccessTokenWithAuthCodeForEve(this.authCode).subscribe(
      (resp) => {
        let data: any;
        const start = new Date().getTime();
        data = resp.body;
        localStorage.setItem('TOKEN', data.access_token);
        localStorage.setItem('TOKEN_EXPIRATION_SECONDS', start + "");
        this.apiService.getUserInfo().subscribe((resp) => {
          this.authUserData = resp.body;
          localStorage.setItem('NAME', this.authUserData.fullname);
          localStorage.setItem('EMAIL', this.authUserData.email);
          this.uploadForm.controls.userName.setValue(
            this.authUserData.fullname
          );
          this.uploadForm.controls.userEmail.setValue(this.authUserData.email);
          if( localStorage.hasOwnProperty("URLHIT") &&  localStorage.getItem('URLHIT')!='' ){
            this.UrlHitIffingerprintInit();
     }
        });
        const self = this;
        self.start = false;
       // alert("Inside auth outside if");
       console.log( localStorage.hasOwnProperty("URLHIT"),'.....',
       localStorage.getItem('URLHIT')!='','.............');
      
      },
      (err) => {
        this.start = false;
        console.log(err);
        if (err.status === 500) {
          alert(
            'There is a temporary Infra issue. Please try after some time/try opening the page in new browser. If still issue exists, please contact support team'
          );
        }
      }
    );

   
  }
  initMethods() {
    //if (isNullOrUndefined(localStorage.getItem('TOKEN'))) {
      if (localStorage.getItem('TOKEN')==='') {
      //  alert("initMethods set token blanlk");
        console.log('initMethods set authcode');
      this.apiService.getAuthCodeUrlForEve().subscribe((resp) => {        
        let result: any;
        result = resp.body;
        this.url = result.message;
        window.location.href = this.url;
      });
    } else {
     // alert("initMethods set token not blanlk username");
      this.uploadForm.controls.userName.setValue(localStorage.getItem('NAME'));
      this.uploadForm.controls.userEmail.setValue(localStorage.getItem('EMAIL'));
        //for external link google alystics
if(this.router.snapshot.queryParams['fingerprint'] ){
  this.googleAnalyticsFunction('EncryptedVisibilityEngine','External','EncryptedVisibilityEngine',
  localStorage.getItem('NAME')+"("+localStorage.getItem('EMAIL')+"): "+'  ->' +  window.location.href.slice(window.location.href.lastIndexOf('/eve?') + 5));
  amplitude.getInstance().logEvent("EncryptedVisibilityEngine_External",{ "Customer Name": localStorage.getItem('NAME'), "Email": localStorage.getItem('EMAIL') , "Data" :  window.location.href.slice(window.location.href.lastIndexOf('/eve?') + 5)  });
}

    }
  }

  UrlHitIffingerprintInit(){

          this.urlNeedToHit=localStorage.getItem('URLHIT');
          localStorage.removeItem('URLHIT');
           window.location.href = this.urlNeedToHit;           
         this.googleAnalyticsFunction('EncryptedVisibilityEngine','External','EncryptedVisibilityEngine',
        localStorage.getItem('NAME')+"("+localStorage.getItem('EMAIL')+"): "+'  ->' +  window.location.href.slice(window.location.href.lastIndexOf('/eve?') + 5));
        amplitude.getInstance().logEvent("EncryptedVisibilityEngine_External",{ "Customer Name": localStorage.getItem('NAME'), "Email": localStorage.getItem('EMAIL') , "Data" :  window.location.href.slice(window.location.href.lastIndexOf('/eve?') + 5)  });
       
  }

  onSubmit() {
    console.log('Inside submit method');
    this.submitted = true;
    this.isChecked =false;
    this.applicationList = [];
    this.processNameArr = [];
    if (this.uploadForm.invalid) {
      return;
    }
  
    console.log('Inside submit cal sec'+this.calculateTokenSeconds());
    // If token has been exipre then perform all the step again
    if(this.calculateTokenSeconds() > 3600){
      console.log('Inside cal sec if'+this.calculateTokenSeconds());
      localStorage.setItem('TOKEN', '');
      localStorage.setItem('TOKEN_EXPIRATION_SECONDS','');
      if (this.router.snapshot.queryParams['fingerprint']  ) {
        localStorage.setItem('URLHIT', window.location.href);
        console.log("Inside if ",localStorage.getItem('URLHIT'));
      }

      if (this.authCode != null && this.authCode !== '' && localStorage.getItem('TOKEN')===''){
        console.log("authenticate");
        this.authenticate();
      }else {
        console.log("initMethods");
        this.initMethods();   
      }
    }
  

    /* if(this.uploadForm.value.applicationLog!=null && this.uploadForm.value.applicationLog!=''){
      this.parseApplicationLog();
    } */
    const formData = new FormData();
    const jsonData = this.uploadForm.value;
    this.serverName = this.uploadForm.value.server_name;
    this.ipAddress = this.uploadForm.value.ip_address;
    this.port = this.uploadForm.value.port;
    this.fingerPrint = this.uploadForm.value.str_repr;
    console.log('Server Name : ' + this.serverName); 

    delete jsonData.userName;
    delete jsonData.userEmail;
    delete jsonData.customerName;
    delete jsonData.applicationLog;

    if (jsonData.vdb_version === '' || jsonData.vdb_version == null) {
      jsonData.vdb_version = 'latest';
    }
    if (jsonData.port === '' || jsonData.port == null) {
      jsonData.port = '443';
    }
    if (jsonData.ip_address === '' || jsonData.ip_address == null) {
      jsonData.ip_address = 'None';
    }
    if (jsonData.server_name === '' || jsonData.server_name == null) {
      jsonData.server_name = 'None';
    }

    //Request Submitted -> New Detector -> Customer
    
    //this.googleAnalyticsFunction('Support','New Application Request','Request Submitted -> New Detector -> '+jsonData.customerName);


    formData.append('fingerprintparameter', JSON.stringify(jsonData));
    this.apiService.submitFingerPrintRequest(formData).subscribe(
      (resp) => {
      /*  if(resp===null){
          alert('No records found for the below input details.');
        }else{*/
          this.showsuccess = true;
          this.jsonData = JSON.parse(JSON.stringify(resp));
          
          this.applicationList = resp;
          
          //console.log(this.jsonData.applicationList);
  
          this.applicationList = this.jsonData.applicationList;
          console.log('length ' + this.applicationList.length);

          console.log(this.applicationList);
          //this.uploadForm.reset();
          this.uploadForm.controls.userName.setValue(localStorage.getItem('NAME'));
          this.uploadForm.controls.userEmail.setValue(localStorage.getItem('EMAIL'));
          this.submitted = false;
      //  }
      },
      (error) => {
        alert('Error loading values due to Invalid Entries.');
        console.log(error);
        // Error callback
        this.showerror = true;
        this.showErrorMessage = error.error;
      }
    );
    this.isViewReqBtnClicked = true;
    this.createFilterUrl();
    this.linkedHoverCopiedText = 'Copy Link';
  }
  get f() {
    return this.uploadForm.controls;
  }

  closeSuccess() {
    this.showsuccess = false;
  }

  closeError() {
    this.showerror = false;
  }

  createForm() {
    this.uploadForm = new FormGroup({

      userName: new FormControl(localStorage.getItem('NAME')),
      userEmail: new FormControl(localStorage.getItem('EMAIL')),
      customerName: new FormControl(''),
      str_repr: new FormControl('',Validators.required),
      server_name: new FormControl(''),
      port: new FormControl(''),
      vdb_version: new FormControl(''),
      ip_address: new FormControl(''),
      applicationLog: new FormControl('')

    });
  }

  sortDirection: string = 'asc';
  sortData(column: string, dir: boolean) {
    let sortOrder = 0;
    this.sortDirectionCss(column);
    if (dir) {
      if (this.sortDirection === 'desc') {
        sortOrder = -1;
        this.sortDirection = 'asc';
      } else {
        sortOrder = 1;
        this.sortDirection = 'desc';
      }
    } else {
      sortOrder = 1;
    }
    this.applicationList.sort((a, b) => (a.column > b.column) ? 1 * sortOrder : -1 * sortOrder);

  }
  sortObj: any = {
    process_name: 'default',
    prevalance: 'default',
    server_name: 'default',
    ip_address: 'default',
    port: 'default'
  };
  sortDirectionCss(propName: string) {
    for (const key in this.sortObj) {
      if (key === propName) {
        this.sortObj[key] = this.sortDirection;
      } else {
        this.sortObj[key] = 'default';
      }
    }
  }
  getSortingClass(prop: string) {
    return this.sortObj[prop];
  }
  parseApplicationLog() {
    var string = '192.168.1.231 58265 -> 13.107.136.9 443 6 AS=4 ID=1 process: microsoft office, process_score: 1.000000, threat: false, threat_score: 0.000000, server name: cisco-my.sharepoint.com, fingerprint: tls/(0303)(0a0a130113021303c02cc02bcca9c030c02fcca8c00ac009c014c013009d009c0035002fc008c012000a)((0a0a)(0000)(0017)(ff01)(000a000c000a0a0a001d001700180019)(000b00020100)(0010000e000c02683208687474702f312e31)(000500050100000000)(000d0018001604030804040105030203080508050501080606010201)(0012)(0033)(002d00020101)(002b000b0a0a0a0304030303020301)(001b0003020001)(0a0a)(0015))';
    var matchserverFingerPrintRegexp;
    var ipAddressPortRegexpRegexp;
    var matchserverRegexp;
    var serverFingerPrintRegexp = /.server name: ([a-z-0-9. ]+)(.)/;
    var ipAddressPortRegexp = /.*[0-9]+ -> ([0-9.]+) ([0-9]+)/;
    
   // var serverFingerPrintRegexp = /.fingerprint: (.+)/;
    var fingerPrintIdRegexp = /.fingerprint: (.+)/;

    console.log('parseApplicationLog ' + this.uploadForm.value.applicationLog);

    var applicationLog = this.uploadForm.value.applicationLog;

    matchserverRegexp = applicationLog.match(serverFingerPrintRegexp);
    matchserverFingerPrintRegexp = applicationLog.match(fingerPrintIdRegexp);
    ipAddressPortRegexpRegexp = applicationLog.match(ipAddressPortRegexp);

    this.uploadForm.controls.str_repr.setValue(matchserverFingerPrintRegexp[1]);

    this.uploadForm.controls.ip_address.setValue(ipAddressPortRegexpRegexp[1]);
    this.uploadForm.controls.port.setValue(ipAddressPortRegexpRegexp[2]);
    this.uploadForm.controls.server_name.setValue(matchserverRegexp[1]);

  }
  setFieldsFromUrlParameters() {
    let isAllValuesSet = false;
    if (this.router.snapshot.queryParams['fingerprint']) {
      this.uploadForm.controls.str_repr.setValue(this.router.snapshot.queryParams['fingerprint']);
      isAllValuesSet = true;
    }
    if (this.router.snapshot.queryParams['ip_address']) {
      this.uploadForm.controls.ip_address.setValue(this.router.snapshot.queryParams['ip_address']);
      isAllValuesSet = true;
    }
    if (this.router.snapshot.queryParams['port']) {
      this.uploadForm.controls.port.setValue(this.router.snapshot.queryParams['port']);
      isAllValuesSet = true;
    }
    if (this.router.snapshot.queryParams['server_name']) {
      this.uploadForm.controls.server_name.setValue(this.router.snapshot.queryParams['server_name']);
      isAllValuesSet = true;
    }
    if (this.router.snapshot.queryParams['vdb_version']) {
      this.uploadForm.controls.vdb_version.setValue(this.router.snapshot.queryParams['vdb_version']);
      isAllValuesSet = true;
    }
    this.createFilterUrl();
    return isAllValuesSet;
  }
  createFilterUrl() {
    const hostname = window.location.hostname;
    let queryParameters = '';
    this.mainUrl = '';

    if (hostname === 'localhost') {
      this.mainUrl = location.protocol + '//' + location.hostname + ':' + location.port +
        '/eve?fingerprint=' + this.uploadForm.value.str_repr + "&ip_address=" + this.uploadForm.value.ip_address + "&port=" + this.uploadForm.value.port + "&server_name=" + this.uploadForm.value.server_name + "&vdb_version=" + this.uploadForm.value.vdb_version;
    } else {
      this.mainUrl = location.protocol + '//' + location.hostname + '/eve?fingerprint=' + this.uploadForm.value.str_repr + "&ip_address=" + this.uploadForm.value.ip_address + "&port=" + this.uploadForm.value.port + "&server_name=" + this.uploadForm.value.server_name + "&vdb_version=" + this.uploadForm.value.vdb_version;
    }
    //console.log(this.mainUrl);
  }
  copyToClipboard() {
    //navigator.clipboard.writeText(this.mainUrl).then().catch(e => console.error(e));

    this.createFilterUrl();
    navigator.clipboard.writeText(this.mainUrl).then(function () {
      console.log('Link copied...');
    }, function () {
      console.log('Link copying failed...');
    });
    //this.copyTo(this.mainUrl);
    this.isLinkCopied = !this.isLinkCopied;
    this.linkedHoverCopiedText = "Copied to clipboard";
    (document.getElementById('linkClicked') as HTMLInputElement).setAttribute("class", "tooltip__text_copied");
    setTimeout(() => {

      //(document.getElementById('linkClicked') as HTMLInputElement).setAttribute("min-width", "100px");

    }, 5000);
  }
  getLinkcopiedCss() {
    if (this.linkedHoverCopiedText === 'Copied to clipboard') {
      return 'tooltip__text_copied';
    } else {
      return 'tooltip__text';
    }
  }
  openModal(modalType) {

    (document.getElementById(modalType) as HTMLInputElement).style.display = 'block';
    (document.getElementById('backdrop') as HTMLInputElement).style.display = 'block';

  }

  closeModal(modalType) {
    (document.getElementById(modalType) as HTMLInputElement).style.display = 'none';
    (document.getElementById('backdrop') as HTMLInputElement).style.display = 'none';
    //this.isChecked = false;
  }
  selectedRow: string = '';
  isSubmitReqBtnDisabled: boolean = true;
  processNameArr = [];
  userObj = {
    process: [],
    str_repr: "",
    server_name: "",
    ip_address: "",
    port: "",
    customer_id: localStorage.getItem('EMAIL'), 
    feedback: "",
    currentProcessView :""
  };

  getSelectedProcess(selectedAppId: any, processName: string, event: any) {
    this.isChecked = event.target.checked;
    this.selectedRow = selectedAppId;

    if (this.isChecked) {
      (document.getElementById(this.selectedRow) as HTMLInputElement).style.background = "#D6F2FF";
      this.isSubmitReqBtnDisabled = false;

      if (!this.processNameArr.includes(processName)) {
        this.processNameArr.push(processName);
       
      }
      
      this.fingerPrint = this.uploadForm.value.str_repr;
      this.serverName = this.uploadForm.value.server_name;
      this.ipAddress = this.uploadForm.value.ip_address;
      this.port = this.uploadForm.value.port;

      this.userObj.process = this.processNameArr;
      this.setApplicationObjDetails();
    /*  this.userObj.str_repr = this.fingerPrint;
      this.userObj.server_name = this.serverName;
      this.userObj.ip_address = this.ipAddress;
      this.userObj.port = this.port;
      this.userObj.customer_id = localStorage.getItem('EMAIL');
      this.userObj.currentProcessView = this.mainUrl;*/
    } else {

      (document.getElementById(this.selectedRow) as HTMLInputElement).style.background = "";
      if (this.processNameArr.includes(processName)) {

        const index = this.processNameArr.indexOf(processName, 0);
        if (index > -1) {
          this.processNameArr.splice(index, 1);
          this.isChecked = true;
        }
        if (this.processNameArr.length === 0) {
          this.isSubmitReqBtnDisabled = true;
          this.isChecked = false;
        }
      }
    }
  }
/*  submitRequest() {
    if (this.isChecked) {
      //(document.getElementById(this.selectedRow) as HTMLInputElement).style.background = "#D6F2FF";
      this.openModal('feedback');
    } else {
      (document.getElementById(this.selectedRow) as HTMLInputElement).style.background = "";
      this.closeModal('feedback');
    }
  } */

  submitRequest() {  
      //(document.getElementById(this.selectedRow) as HTMLInputElement).style.background = "#D6F2FF";
      this.openModal('feedback');   
  }

  submitRequestFeedback(feedBackData: string) {

    if (!localStorage.hasOwnProperty("EMAIL") ||  localStorage.getItem('EMAIL')!='' || localStorage.getItem('EMAIL') ) {
      this.authenticate();
        console.log('....customerid inside submit request feedback ...'+localStorage.getItem('EMAIL'));
    }
    this.setApplicationObjDetails();
    const formData = new FormData();
    this.userObj.feedback = feedBackData;
    let submitData = JSON.stringify(this.userObj);
    console.log("submitData : " + submitData);
    formData.append('submitRequestData', submitData);
    console.log("user : " + this.userObj.customer_id);
    this.googleAnalyticsFunction('EncryptedVisibilityEngine','Request_Submitted','EncryptedVisibilityEngine',
    localStorage.getItem('NAME')+"("+this.userObj.customer_id+"): "+' Request Submitted ->' + submitData);
    amplitude.getInstance().logEvent("EncryptedVisibilityEngine_Request_Submitted",{ "Customer Name": localStorage.getItem('NAME'), "Email": localStorage.getItem('EMAIL') , "Data" :  submitData  });
     this.apiService.submitRequest(formData).subscribe(
     (resp) => {
        console.log(JSON.parse(JSON.stringify(resp)).message);
        alert(JSON.parse(JSON.stringify(resp)).message);
      });
    
      for(var pname in this.processNameArr){
        console.log(pname);
        
        (document.getElementById(this.processNameArr[pname]) as HTMLInputElement).checked = false;
      }
      for(var appcount in this.applicationList){
        (document.getElementById(appcount) as HTMLInputElement).style.background = "";
      }
      this.processNameArr = [];
  }
  submitWithFeedBack() {
    this.submitRequestFeedback(this.feedBackDetails);
    this.closeModal('feedback');
    this.feedBackDetails = '';
  }
  submitWithOutFeedBack() {
    this.submitRequestFeedback('');
    this.closeModal('feedback');
    this.feedBackDetails = '';
  }

  calculateTokenSeconds() {
    var startDate = localStorage.getItem('TOKEN_EXPIRATION_SECONDS');//1662020766029
    // Do your operations
    var endDate = new Date();
    var seconds = (endDate.getTime() - parseInt(startDate)) / 1000;
    return seconds;
  }

  openUrl(){
    window.open('https://secure.cisco.com/secure-firewall/v7.2/docs/encrypted-visibility-engine', '_blank');
  }

  setApplicationObjDetails(){
    this.userObj.str_repr = this.fingerPrint;
    this.userObj.server_name = this.serverName;
    this.userObj.ip_address = this.ipAddress;
    this.userObj.port = this.port;
    this.userObj.customer_id = localStorage.getItem('EMAIL');
    this.userObj.currentProcessView = this.mainUrl;


}  


googleAnalyticsFunction(actionName : string ,category : string, eventName : string,eventLabel : string) {

  this.googleAnalyticsService.eventEmitter(
    actionName,      //eventName -> Partner Help
    category,       //evtCategory ->Menu
    eventName,    //evtAction -> Sales
    eventLabel, //evtLabel -> Partner Help
    1           //evtValue
  );
}

copyExternalLink(value:string){
  this.externalUrl="https://panacea.threatgrid.com/mask/indicators?page=0&query=%7B%22samplesActive%22%3A%7B%22key%22%3A%22all%22%2C%22value%22%3A%22all%22%7D%2C%22scope%22%3A%7B%22key%22%3A%22all%22%2C%22value%22%3A%22all%22%7D%2C%22dateRange%22%3A%7B%22key%22%3A%22withinlast90days%22%7D%2C%22state%22%3A%7B%22active%22%3Atrue%7D%2C%22query%22%3A%7B%22option%22%3Anull%2C%22value%22%3A%22"+value+"%22%7D%7D&region=US";
  window.open( this.externalUrl, '_blank'); 
 
}


}

